import React                        from 'react';
import PropTypes                    from 'prop-types';
import Flux                         from '../../../flux/Flux';
import Translations                 from '../../../utils/Translations';
import DailybonusTodayOfferHeadLine from './DailybonusTodayOfferHeadLine';
import DailyBonusOfferBtn           from '../SubComponents/DailyBonusOfferBtn';
import OfferIcon                    from '../SubComponents/OfferIcon';
import {getTopUpGteThenValue}       from '../dailyBonusHelpers';
import {getCurrencySymbol}          from '../../../utils/CommonUtils.js';


const {signature, offerBgs} = Flux.Constants.DailyBonuses;


class DailybonusTodayMessengerGiftOffer extends React.Component {
	render() {
		const {offer, purchased, content, quantity, conditions, effect} = this.props;
		const {imageUrl, name} = content ? content : {};
		return (
			<div className='dailybonus-today-item'>
				<DailybonusTodayOfferHeadLine
					purchased={purchased}
					offer={offer}
				/>
				<div className="dailybonus-today-item__wrapper">
					<div className="dailybonus-today-item__left-side"
					     style={{backgroundImage: `url(${offerBgs.MESSENGER_GIFT})`}}
					>
						<div className="dailybonus-today-item__left-side--bottom-plate">
							<div className="dailybonus-today-item__left-side--bottom-plate__signature">{signature.MESSENGER_GIFT}</div>
						</div>
					</div>
					<div className="dailybonus-today-item__right-side">
						<div className="dailybonus-today-item__right-side__icon"><OfferIcon offer={offer} purchased={purchased} /></div>
						<div className='dailybonus-today-item__right-side__offer-effect-wrapper'>
							<img className='dailybonus-today-item__right-side__offer-effect__bonusimg'
							     src={imageUrl}
							     alt={name}
							/>
							{quantity && <span className="dailybonus-today-item__right-side__offer-effect-quantity">{quantity}x</span>}
						</div>
						<div className="dailybonus-today-item__right-side__title">{Translations.get('MessengerGift365')}</div>
						<div className="dailybonus-today-item__right-side__description">
							{Translations.get('MessengerGift365Minimum', getTopUpGteThenValue(conditions))} {getCurrencySymbol()}
						</div>
						<DailyBonusOfferBtn
							purchased={purchased}
							offer={offer}
							content={content}
							effect={effect}
							conditions={conditions}
							quantity={quantity}
						/>
					</div>
				</div>
			</div>
		);
	}
}

DailybonusTodayMessengerGiftOffer.propTypes = {
	offer:      PropTypes.string.isRequired,
	purchased:  PropTypes.bool,
	content:    PropTypes.object.isRequired,
	effect:     PropTypes.object,
	quantity:   PropTypes.number,
	conditions: PropTypes.array,
};

DailybonusTodayMessengerGiftOffer.defaultProps = {
	purchased:  false,
	content:    {},
	quantity:   0,
	conditions: [],
	effect:     {},
};

export default DailybonusTodayMessengerGiftOffer;
